import { useId } from "react";
import PropTypes from "prop-types";
import { Slider, Box, Typography } from "@mui/material";
import { useRewampT } from "../../../localisation";

export default function FilterRangeSliderField({
  controlId,
  labelKey,
  label,
  bounds,
  value,
  onChange,
  formatValue,
}) {
  const tRewamp = useRewampT();
  const resolvedLabel = label || (labelKey ? tRewamp(labelKey) : undefined);
  const fallbackId = useId();
  const safeId = controlId || fallbackId;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {formatValue(value[0])}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {formatValue(value[1])}
        </Typography>
      </Box>
      <Slider
        id={safeId}
        value={value}
        onChange={(e, next) => onChange(next)}
        valueLabelDisplay="off"
        min={bounds[0]}
        max={bounds[1]}
        disableSwap
        getAriaLabel={(index) => `${resolvedLabel ?? ""} ${tRewamp(index ? "FILTER_ROW.MAX" : "FILTER_ROW.MIN")}`.trim()}
        getAriaValueText={formatValue}
      />
    </Box>
  );
}

FilterRangeSliderField.propTypes = {
  controlId: PropTypes.string,
  labelKey: PropTypes.string,
  label: PropTypes.string,
  bounds: PropTypes.arrayOf(PropTypes.number).isRequired,
  value: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
  formatValue: PropTypes.func,
};

FilterRangeSliderField.defaultProps = {
  controlId: undefined,
  labelKey: null,
  label: null,
  formatValue: (v) => v,
};
